module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/banner-recruiter-aaa5fe2f068c938c4167bb634536276e.jpg";